import React from 'react';

function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="fixed inset-0 bg-black/30" 
        onClick={onClose}
      ></div>
      <div className="relative z-50 max-w-lg w-full mx-3">
        {children}
      </div>
    </div>
  );
}

export default Modal; 